var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoCoachesGreenCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.667,
    height: 16.667,
    viewBox: "0 0 16.667 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(-4.091 8.333) rotate(-45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 17.571,
    transform: "translate(0 8.785)",
    fill: "none",
    stroke: "#33be21",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y1: 17.571,
    transform: "translate(8.785 0)",
    fill: "none",
    stroke: "#33be21",
    strokeLinecap: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoCoachesGreenCross);
export default __webpack_public_path__ + "static/media/co-coaches-green-cross.d2c75c6e398a28131227a11c5b6a618d.svg";
export { ForwardRef as ReactComponent };